import React from 'react'
import Select from '../../../../Input/Select'
import options from './lib/options'

export default (props) => (
  <Select label='Status' name='status' options={options} {...props} />
)
